import styled from '@emotion/styled'
import { css } from '@emotion/react'

import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import SectionBlock from './SectionBlock'
import Input from '@src/components/inputs/Input'
import VariantOptionForm from './VariantOptionForm'

const VariantForm = () => {
	const { getFieldProps, getProductVariantsFormProps } = useMyProductFormContext()
	const { variantFields, appendVariantField, removeVariantField, isOptionExist } =
		getProductVariantsFormProps()

	if (!isOptionExist) return null
	return (
		<SectionBlock title="상품옵션" btnTxt="옵션추가" onClick={appendVariantField} isButton>
			{variantFields.map((variantField, index) => {
				return (
					<OptionBlock key={variantField.id}>
						<OptionInputBlock>
							<Input
								{...getFieldProps(`productVariants.${index}.name`)}
								label={`옵션명${index + 1}. (ex. 맛, 색상, 구성 등)`}
								placeholder="ex. 색상"
								css={inputStyle}
								wrapperStyle={wrapperStyle}
								labelStyle={labelStyle}
							/>
							<VariantOptionForm depth={variantField.depth} />
						</OptionInputBlock>
						<DeleteOptionBtn type="button" onClick={() => removeVariantField(index)}>
							삭제
						</DeleteOptionBtn>
					</OptionBlock>
				)
			})}
		</SectionBlock>
	)
}

const OptionBlock = styled.div`
	display: flex;
	align-items: flex-start;
	width: 72.2rem;
	padding-bottom: 1.5rem;
	&:last-child > div {
		border-bottom: none;
	}
`

const OptionInputBlock = styled.div`
	display: flex;
	width: 58.6rem;
	border-bottom: 1px solid #000;
	padding-bottom: 1.5rem;
`

const DeleteOptionBtn = styled.button`
	border: none;
	border-radius: 0.4rem;
	background-color: #92959e;
	color: #fff;
	font-size: 1.6rem;
	font-weight: 600;
	width: 7.6rem;
	height: 3.9rem;
	margin-top: 5rem;
	margin-left: 5rem;
`

const wrapperStyle = css`
	flex-direction: column;
	width: auto;
`

const labelStyle = css`
	width: 100%;
`

const inputStyle = css`
	width: 25.8rem;

	&:nth-of-type(1) {
		margin-right: 5rem;
	}
`

export default VariantForm
